import MultipleKakuzaisField from '../components/multiple_kakuzais_field'

export default {
  components: {
    MultipleKakuzaisField
  }
}